// extracted by mini-css-extract-plugin
module.exports = {"colItem":"BookList_colItem__3t56e","books":"BookList_books__3A9XK","menuSubTitle":"BookList_menuSubTitle__1qGbv","dropDownTitle":"BookList_dropDownTitle__258nC"};